const isNonEmptyString = (value) => typeof value === "string" && value.trim().length > 0;

export const replaceUrlInText = (text, oldUrl, newUrl) => {
  if (!isNonEmptyString(text) || !isNonEmptyString(oldUrl) || !isNonEmptyString(newUrl) || oldUrl === newUrl) {
    return text;
  }
  return text.split(oldUrl).join(newUrl);
};

const dedupeStrings = (items = []) => {
  const seen = new Set();
  const result = [];
  items.forEach((item) => {
    if (!isNonEmptyString(item) || seen.has(item)) return;
    seen.add(item);
    result.push(item);
  });
  return result;
};

const replaceUrlListItem = (url, oldUrl, newUrl) => (url === oldUrl ? newUrl : url);

const syncUrlList = (items, oldUrl, newUrl, { ensureNewUrl = false } = {}) => {
  const replaced = (Array.isArray(items) ? items : []).map((url) => replaceUrlListItem(url, oldUrl, newUrl));
  if (ensureNewUrl && isNonEmptyString(newUrl) && !replaced.includes(newUrl)) {
    replaced.unshift(newUrl);
  }
  return dedupeStrings(replaced);
};

const normalizeHistoryItem = (item) => {
  if (!item) return null;
  if (typeof item === "string") {
    return { type: "image", url: item, created_at: Date.now() };
  }
  if (typeof item === "object" && isNonEmptyString(item.url)) {
    return item;
  }
  return null;
};

const appendImageHistory = (historyList, historyItem) => {
  if (!historyItem?.url) return historyList;
  const normalized = (Array.isArray(historyList) ? historyList : [])
    .map(normalizeHistoryItem)
    .filter(Boolean)
    .filter((item) => item.url !== historyItem.url);
  return [...normalized, historyItem].slice(-10);
};

export const syncGeneratedImageForRow = (row, nextUrl, options = {}) => {
  if (!row || !isNonEmptyString(nextUrl)) return row;

  const oldUrl = options.oldUrl ?? row.generated_image;
  const historyItem = options.historyItem ?? {
    type: "image",
    url: nextUrl,
    prompt: row.image_prompt || row.visual_content || row.action || "",
    model: options.model || row.image_model || "image",
    source: options.source,
    created_at: Date.now(),
  };

  const imageCandidates = syncUrlList(row.image_candidates, oldUrl, nextUrl, {
    ensureNewUrl: options.ensureCandidate !== false,
  });
  const guaRefs = syncUrlList(row.video_gua_ref_images, oldUrl, nextUrl);

  return {
    ...row,
    generated_image: nextUrl,
    image_task_status: "success",
    image_task_id: options.clearImageTask === false ? row.image_task_id : null,
    image_candidates: imageCandidates,
    video_gua_ref_images: guaRefs,
    video_prompt: replaceUrlInText(row.video_prompt, oldUrl, nextUrl),
    first_frame_image: row.first_frame_image === oldUrl ? nextUrl : row.first_frame_image,
    last_frame_image: options.clearLastFrame
      ? null
      : (row.last_frame_image === oldUrl ? nextUrl : row.last_frame_image),
    lastFrameImage: options.clearLastFrame
      ? null
      : (row.lastFrameImage === oldUrl ? nextUrl : row.lastFrameImage),
    history_list: options.addHistory === false
      ? row.history_list
      : appendImageHistory(row.history_list, historyItem),
  };
};
